export interface ParsedAddress {
  street: string;
  city: string;
  // Two-letter state code (short_name), matching the US_STATES constant.
  state: string;
  zipCode: string;
}

const findComponent = (
  components: google.maps.GeocoderAddressComponent[],
  type: string,
  useShortName = false,
): string => {
  const component = components.find((c) => c.types.includes(type));
  if (!component) return "";
  return useShortName ? component.short_name : component.long_name;
};

// Extracts the fields an address form typically needs (street/city/state/zip)
// out of a Google Geocoder result's address_components.
export const parseAddressComponents = (
  components: google.maps.GeocoderAddressComponent[],
): ParsedAddress => {
  const streetNumber = findComponent(components, "street_number");
  const route = findComponent(components, "route");

  return {
    street: [streetNumber, route].filter(Boolean).join(" "),
    city:
      findComponent(components, "locality") ||
      findComponent(components, "sublocality") ||
      findComponent(components, "postal_town"),
    state: findComponent(components, "administrative_area_level_1", true),
    zipCode: findComponent(components, "postal_code"),
  };
};
